import { v4 } from 'uuid';

function uuid() {
  return v4();
}

export default uuid;
